import type { ReactNode } from "react";

import { cn } from "@krea/shared/utils";

import { DataStatusIndicator } from "../data-status-indicator";

export const DetailsItemGridData = ({
  title,
  value,
  tooltip,
  indicator,
  isDone,
  notExists,
}: {
  title: string;
  value?: string | ReactNode;
  tooltip?: string;
  indicator?: boolean;
  isDone?: boolean;
  notExists?: boolean;
}) => {
  const notExistsText = "No information";

  const data = notExists ? notExistsText : value;

  let styling = {};

  if (notExists) {
    styling = { opacity: "0.7" };
  }

  return (
    <>
      <dt className=" mb-2 p-0 font-bold text-gray-600 lg:m-0">
        {title && `${title}:`}
      </dt>
      <dd
        className={cn(
          "mb-5 flex items-start justify-between p-0 lg:m-0",
          {
            "text-gray-500": notExists,
          },
        )}
        style={styling}
      >
        <div className="w-full text-ellipsis">{data}</div>

        {indicator && (
          <DataStatusIndicator
            tooltip={!notExists ? tooltip : notExistsText}
            isDone={isDone}
            notExists={notExists}
          />
        )}
      </dd>
    </>
  );
};
